<script lang="ts" setup>
import { ArrowRight } from '@element-plus/icons-vue'
const news = [
  {
    time: '2025.03.25',
    title: '【FaW TOKYOご招待】仕入れコスト削減＆小ロット生産を現場でご案内！',
    img: 'https://static-jp.theckb.com/static-asset/xr/new4.png',
    id: '1'
  },
  {
    time: '2024.5.27',
    title: 'CEO呉氏、早稲田大学にて中国・日本間の越境EC市場を分析',
    img: 'https://static-jp.theckb.com/static-asset/xr/new1.png',
    id: '2'
  },
  {
    time: '2023.11.23',
    title: 'THE CKB × 1688 世界初の協力イベント開催',
    img: 'https://static-jp.theckb.com/static-asset/xr/new2.png',
    id: '3'
  },
]

</script>

<template>
  <div id="news" class=" bg-[#FAFAFA]">
    <ADevice>
      <template #h5>
        <MContainer class="py-[48px]">
          <div class=" flex flex-col gap-4 ">
            <MText size="h1" class="font-black">ニュース</MText>
            <ALink :to="`/news/${v.id}`" v-for="v in news" :key="v.id" class="pb-[16px] border-b  mt-[16px]">
              <ElImage class="w-full h-[197px]" :src="v.img" />
              <div class="text-[12px] leading-[20px] mt-[16px] border-black/45 font-normal">
                <span class="mr-[16px]">{{ v.time }}</span> イベント
              </div>
              <div class="mt-[8px] text-[16px] leading-[24px] text-black/85  font-normal">
                {{ v.title }}
              </div>
            </ALink>
            <ALink to="/news">
              <MButtonLinkP1 class="w-full">
                もっと見る
              </MButtonLinkP1>
            </ALink>
          </div>
        </MContainer>
      </template>
      <template #pc>
        <AContainer class="bg-[#FAFAFA]">
          <div class="w-[1120px] mx-auto py-[72px] text-black/85">
            <div class="font-black text-[48px] leading-[56px] text-center">ニュース</div>
            <div class="flex flex-col mt-[48px]">
              <ALink :to="`/news/${v.id}`" v-for="v in news" :key="v.id"
                class="flex pb-[16px] border-b border-black/5 mb-[16px] items-center">
                <ElImage :src="v.img" class="w-[256px] h-[144px] mr-[32px]" />
                <div class="w-[760px] mr-[32px] flex flex-col justify-center ">
                  <div class="text-[14px] leading-[22px] text-black/85">
                    <span class="mr-[16px]">{{ v.time }}</span>イベント
                  </div>
                  <div class="text-[24px] leading-[32px] mt-[8px] text-black/85">{{ v.title }}</div>
                </div>
                <el-icon size="36px" class="text-black/85">
                  <ArrowRight />
                </el-icon>
              </ALink>
            </div>
            <div class="flex justify-center mt-[48px]">
              <ALink to="/news" class="mx-auto ">
                <MButtonLinkP1 class="w-[280px]">もっと見る</MButtonLinkP1>
              </ALink>
            </div>
          </div>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped></style>
